var changeAddressMixin = {
    data: function () {
        return {
            isEdit: false
        }
    },
    mounted: function() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        if (urlParams.has('edit')) {
            const vm = this;
            vm.isEdit = true;
            vm.useBillingDetails = false;
        }
    }
}